import React, { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Validate from 'app/validation/validation';
import { setSupplierApplication } from "../../../../redux/actions";

//components
import AnimatedInput from "components/forms/animated_input";
import AnimatedTextArea from "components/forms/animated_textarea";

//assets
import './join-form.scss';
import subscribe_banner from 'assets/mock/subscribe_banner.jpg';
import { executeWithCaptcha, getMediaPath } from "../../../../app/functions";
import Recaptcha from "../../../../components/services/google/recaptcha";
import { useSuppliersApplicationMutation } from "redux/api/relations.api";
const JoinForm = (props) => {
    const [form, setForm] = useState({
        full_name: { val: '', valid: false, rules: ['full_name', 'not_empty'], errMsg: '' },
        sector: { val: '', valid: false, rules: ['sector'], errMsg: '' },
        phone: { val: '', valid: false, rules: ['phone', 'not_empty'], errMsg: '' },
        email: { val: '', valid: false, rules: ['email', 'not_empty'], errMsg: '' },
        message: { val: '', valid: false, rules: ['not_empty'], errMsg: '' },
        web_supplier_website: { val: '', valid: false, rules: ['url','not_empty'], errMsg: '' }
    });
    const [firstTry, setFirstTry] = useState(true);
    const [disable, setDisable] = useState(false);

    const deviceState = useSelector(state => state.state.deviceState);
    const text = useSelector(state => state.config.Translations);
    
    const [leadStatus, setLeadStatus] = useState(false);

    const [suppliersApplication, { isLoading: isLoadingSuppliersApplication }] = useSuppliersApplicationMutation();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let validate = Validate(value, form[name].rules);
        let is_valid = validate.valid;
        let msg = validate.msg;
        setForm(prevForm => ({
            ...prevForm,
            [name]: { ...prevForm[name], val: value, valid: is_valid, errMsg: msg }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let form_valid = true;
        let new_state = { ...form };

        for (let field in form) {
            let validate = Validate(form[field].val, form[field].rules);
            let is_valid = validate.valid;
            let msg = validate.msg;

            new_state[field].valid = is_valid;
            new_state[field].errMsg = msg;

            if (!is_valid) {
                form_valid = false;
            }
        }

        setForm(new_state);
        setFirstTry(false);

        if (form_valid) {
            executeWithCaptcha((token) => {
                let payload = {};
                for (let key in form) {
                    payload[key] = form[key].val;
                }
                payload['g-recaptcha-response'] = token;
                setDisable(true);
                handleSuppliersApplication(payload);
            });
        }
    };

    const handleSuppliersApplication = async (payload) => {
        try {
            const response = await suppliersApplication(payload);
            if (response.data) {
                setLeadStatus(true);
            } 
        } catch (error) {
            console.error(error);
        }
    }

    const showError = (field) => {
        return (!firstTry && !form[field].valid);
    };

    const isMobileOrTablet = deviceState === 'mobile' || deviceState === 'tablet';

    return (
        <section className='join-form'>
            <div className='form-wrap'>
                {!leadStatus &&
                    <Fragment>
                        <div className="title">{props.title}</div>
                        <form className='contact-form' onSubmit={handleSubmit}>
                            <div className='desktop-display'>
                                <AnimatedInput className={'field name'}
                                    value={form.full_name.val}
                                    name={'full_name'}
                                    placeholder={text.web_full_name_placeholder}
                                    onChange={handleInputChange}
                                    showError={showError('full_name')}
                                    errorMessage={form.full_name.errMsg}
                                />
                                <AnimatedInput className={'field name'}
                                    value={form.sector.val}
                                    name={'sector'}
                                    placeholder={text.sector_placeholder}
                                    onChange={handleInputChange}
                                    showError={showError('sector')}
                                    errorMessage={form.sector.errMsg}
                                />
                            </div>
                            <div className='desktop-display'>
                                <AnimatedInput className={'field phone'}
                                    value={form.phone.val}
                                    name={'phone'}
                                    placeholder={text.web_phone_placeholder}
                                    onChange={handleInputChange}
                                    showError={showError('phone')}
                                    errorMessage={form.phone.errMsg}
                                />
                                <AnimatedInput className={'field email'}
                                    value={form.email.val}
                                    name={'email'}
                                    placeholder={text.web_burger_contact_placeholder}
                                    onChange={handleInputChange}
                                    showError={showError('email')}
                                    errorMessage={form.email.errMsg}
                                />
                            </div>
                            <AnimatedTextArea className={'field'}
                                value={form.message.val}
                                name={'message'}
                                placeholder={text.web_your_message_placeholder}
                                onChange={handleInputChange}
                                showError={showError('message')}
                                errorMessage={form.message.errMsg}
                            />
                            <AnimatedTextArea className={'field'}
                                value={form.web_supplier_website.val}
                                name={'web_supplier_website'}
                                placeholder={text.web_supplier_website_placeholder}
                                onChange={handleInputChange}
                                showError={showError('web_supplier_website')}
                                errorMessage={form.web_supplier_website.errMsg}
                            />
                            <button type='submit'
                                name="submit"
                                className='submit-btn'>
                                {text.web_send_label}
                            </button>
                        </form>
                        <Recaptcha isFunction={false} enterprise={true} />
                    </Fragment>
                }
                {leadStatus &&
                    <div className='success-div'>
                        <h2 className='success-text'>{text['web_success_app']}</h2>
                    </div>
                }
            </div>
            {!isMobileOrTablet &&
                <img className='back-banner' src={getMediaPath(subscribe_banner)} alt='/' />
            }
        </section>
    );
};

export default JoinForm;
